import { Icon } from '@/lib/icons';
import type { InterviewStyleDetail } from '@/data/client';


/* Read-only view of the effective system prompt for an interview style. */
export function PromptModal({ style, styleId, onClose }: { style: InterviewStyleDetail | null; styleId: string; onClose: () => void }) {
  return (
    <div className="admin-modal" role="dialog" aria-modal="true">
      <div className="admin-modal__scrim" onClick={onClose} />
      <div className="admin-modal__panel">
        <div className="admin-modal__head">
          <div>
            <h3>{style?.label ?? styleId}</h3>
            {style?.description && <p className="dash-muted">{style.description}</p>}
          </div>
          <button className="admin-linkbtn" onClick={onClose} aria-label="Close"><Icon name="x" size={18} /></button>
        </div>
        <p className="dash-muted" style={{ marginBottom: 8 }}>
          This is the exact instruction the AI interviewer runs for accounts on this style.
        </p>
        <pre className="admin-modal__prompt">{style?.prompt ?? 'Loading…'}</pre>
      </div>
    </div>
  );
}

/* ---- content admin tab ----------------------------------------------- */
